__turbopack_context__.v({
  "button": "FishplaceNumbers-module-scss-module__zd3bTa__button",
  "content": "FishplaceNumbers-module-scss-module__zd3bTa__content",
  "descriptionBlock": "FishplaceNumbers-module-scss-module__zd3bTa__descriptionBlock",
  "descriptions": "FishplaceNumbers-module-scss-module__zd3bTa__descriptions",
  "fishplaceInNumbers": "FishplaceNumbers-module-scss-module__zd3bTa__fishplaceInNumbers",
  "loadingContainer": "FishplaceNumbers-module-scss-module__zd3bTa__loadingContainer",
  "numberDescription": "FishplaceNumbers-module-scss-module__zd3bTa__numberDescription",
  "numberItem": "FishplaceNumbers-module-scss-module__zd3bTa__numberItem",
  "numberTitle": "FishplaceNumbers-module-scss-module__zd3bTa__numberTitle",
  "numbers": "FishplaceNumbers-module-scss-module__zd3bTa__numbers",
  "title": "FishplaceNumbers-module-scss-module__zd3bTa__title",
});
